import { useRouter } from 'next/router'

import { DIRECTION } from '~/shared/types/pagination.types'
import getPaginationArray from '~/shared/utils/getPaginationArray.utils'

import PagePicker from './PagePicker'
import UrlPagePicker from './UrlPagePicker'

export default function Pages({
  withLink,
  currPage,
  totalPages,
  lessThan10Pages,
  navigationDirection,
  onSetPageClick,
  url,
  baseUrl,
  squreDesign = false,
}: {
  withLink: boolean
  currPage: number
  totalPages: number
  lessThan10Pages: boolean
  navigationDirection: DIRECTION | null
  onSetPageClick?: (newPage: number) => void
  url?: string
  baseUrl?: string
  squreDesign?: boolean
}): React.ReactElement {
  const router = useRouter()
  const paginationArray = getPaginationArray(
    totalPages,
    lessThan10Pages ? undefined : currPage,
    lessThan10Pages ? undefined : navigationDirection,
  )

  return (
    <>
      {paginationArray.map((page) => {
        return withLink ? (
          <UrlPagePicker
            baseUrl={baseUrl || router.basePath}
            isActivePage={currPage === page}
            isDivider={typeof page === 'string' && page.includes('split')}
            key={page}
            onSetPageClick={onSetPageClick}
            page={typeof page === 'number' ? page : 0}
            squreDesign={squreDesign}
            url={url || router.basePath}
          />
        ) : (
          <PagePicker
            isActivePage={currPage === page}
            isDivider={typeof page === 'string' && page.includes('split')}
            key={page}
            onSetPageClick={onSetPageClick}
            page={typeof page === 'number' ? page : 0}
            squreDesign={squreDesign}
          />
        )
      })}
    </>
  )
}
